import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from './IIconProps';

export const OngoingIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 26 26"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M17.875 0.8125L22.75 5.6875L17.875 10.5625"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M1.625 13V10.5625C1.625 7.87011 3.72677 5.6875 6.31944 5.6875H22.75"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M6.5 25.1875L1.625 20.3125L6.5 15.4375"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M22.75 13.8125V15.9792C22.75 18.3724 20.6482 20.3125 18.0556 20.3125H1.625"
				stroke={variables.bgIconChevron}
			/>
		</svg>
	);
};
